var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyRistaIcon12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 43,
    viewBox: "0 0 34 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8692 32.6457H8.13088V15.1699H0L17 0L34 15.1699H25.8692V32.6457ZM10.8599 30.1469H23.1402V12.6711H27.2898L17 3.48916L6.71027 12.6711H10.8599V30.1469Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 35.1484H25.8633V37.6472H8.125V35.1484Z",
    fill: "#1361F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 40.1406H25.8633V42.6394H8.125V40.1406Z",
    fill: "#1361F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyRistaIcon12);
export default __webpack_public_path__ + "static/media/why_rista_icon12.24834ad1fb41e039a031bbad74871cf3.svg";
export { ForwardRef as ReactComponent };